module.exports = __webpack_public_path__ + "static/media/Organising-commitee.c3e916fa.jpg";